import { useConnection } from '@/queries/connections/useConnection'
import { useStytchOrganization } from '@stytch/react/b2b'
import { FC } from 'react'
import { useParams } from 'react-router-dom'

import { GoogleAdsConnectionDetails } from './GoogleAdsConnectionDetails'

export const ConnectionDetails: FC = () => {
	const { connectionId } = useParams<{
		workspaceId: string
		connectionId?: string
		platform?: string
	}>()
	const { organization } = useStytchOrganization()
	const { data: connection } = useConnection({
		workspaceId: organization?.organization_id,
		connectionId,
	})

	if (connection?.platform === 'google_ads') {
		return <GoogleAdsConnectionDetails connection={connection} />
	}

	return <div>Select a connection type to create, or view an existing connection.</div>
}
